import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { App } from '@/graphql/__generated/sdk';
import GroupNavItem from './GroupNavItem';
import { mobileNavigationStyles } from './GroupNavItem.styles';
import { navigationStyles } from '@components/Header/HeaderDesktop/HeaderDesktop.styles';
interface IGroupNavList {
  headerData: App['header'];
  dataTestId?: string;
  isMobile?: boolean;
  toolbarRef?: React.RefObject<HTMLDivElement>;
}
export default function GroupNavList({
  headerData,
  dataTestId,
  isMobile,
  toolbarRef
}: Readonly<IGroupNavList>) {
  const navItems = headerData?.navigationMenu?.headerMainNavLinksCollection?.items;
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const theme = useTheme();
  const isDesktopViewport = useMediaQuery(theme.breakpoints.up('md'));

  // HeaderDesktop and HeaderMobile (and their own GroupNavList) are both mounted at once and toggled via
  // CSS breakpoints, so resizing across the breakpoint doesn't unmount the one with a menu still open.
  // Close it so the now-hidden header isn't left showing an open (portaled) menu over the visible one.
  useEffect(() => {
    setActiveIndex(null);
  }, [isDesktopViewport]);

  // The Popover backdrop no longer blocks clicks (see GroupNavDesktopMenu), so handle click-away closing here instead.
  useEffect(() => {
    if (activeIndex === null) {
      return undefined;
    }
    const handleOutsideClick = (event: MouseEvent) => {
      const target = event.target as Node;
      // The dropdown/drawer content is rendered into a portal, so it's never a descendant of containerRef;
      // detect it via the MuiModal-root class that both Popover and Drawer render instead.
      const isInsideMenuPortal = target instanceof Element && target.closest('.MuiModal-root');
      if (!containerRef.current?.contains(target) && !isInsideMenuPortal) {
        setActiveIndex(null);
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [activeIndex]);
  return <Box ref={containerRef} data-testid={dataTestId} sx={isMobile ? mobileNavigationStyles : navigationStyles} data-sentry-element="Box" data-sentry-component="GroupNavList" data-sentry-source-file="GroupNavList.tsx">
			{navItems?.map((navItem, index) => navItem ? <GroupNavItem key={navItem.headerMainNavLink?.sys.id ?? index} item={navItem} itemIndex={index} isMobile={isMobile} toolbarRef={toolbarRef} open={activeIndex === index} onToggle={() => setActiveIndex(current => current === index ? null : index)} onClose={() => setActiveIndex(null)} /> : null)}
		</Box>;
}